export default "__VITE_ASSET__CTHdegQd__"